function toggleSpeaker(speaker) {
  // speaker is an Element (or a jQuery object in the old code)
  // normalize in case someone passes a jQuery-wrapped element
  const el = speaker && speaker.jquery ? speaker[0] : speaker;

  if (!el) return;

  if (el.classList.contains("active")) {
    document.querySelectorAll(".speaker-intro.active").forEach((n) => n.classList.remove("active"));
    document
      .querySelectorAll(".speakers-biographies.featured-speakers.speaker-expanded")
      .forEach((n) => n.classList.remove("speaker-expanded"));
  } else {
    document.querySelectorAll(".speaker-intro.active").forEach((n) => n.classList.remove("active"));
    el.classList.add("active");
    document
      .querySelectorAll(".speakers-biographies.featured-speakers")
      .forEach((n) => n.classList.add("speaker-expanded"));
    el.scrollIntoView();
  }
}

function initSpeakers() {
	document.querySelectorAll(".speaker-intro.has-details").forEach((node) => {
	  node.addEventListener("click", function () {
	    toggleSpeaker(this);
	  });
	});

	document.querySelectorAll(".speaker-bio .close-bio").forEach((node) => {
	  node.addEventListener("click", function () {
	    // jQuery: $(this).parent('.speaker-bio').prev('.speaker-intro')
	    const bio = this.closest(".speaker-bio");
	    const intro = bio ? bio.previousElementSibling : null;

	    if (intro && intro.matches(".speaker-intro")) {
	      toggleSpeaker(intro);
	    }
	  });
	});

	if (document.querySelectorAll(".speakers-biographies").length) {
	  var speakerHash = location.hash; // e.g. "#some-id"
	  if (speakerHash && document.querySelector(speakerHash + ".speaker-intro")) {
	    // original: toggleSpeaker($(speakerHash));
	    toggleSpeaker(document.querySelector(speakerHash));
	  }
	}
}

document.addEventListener("DOMContentLoaded", initSpeakers);